/**
 * Merchants API Service
 * API calls for fetching merchant data from Core DB
 */

import api from './api';

export interface Merchant {
  id: number;
  uid: string;
  first_name: string;
  last_name: string;
  full_name: string;
  email: string | null;
  phone: string | null;
  city_id: number | null;
  created_at: string;
}

/**
 * Get all merchants
 */
export async function getMerchants(search?: string): Promise<Merchant[]> {
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  
  const response = await api.get<{ success: boolean; data: Merchant[] }>(
    `/merchants${params.toString() ? `?${params.toString()}` : ''}`
  );
  return response.data.data;
}

/**
 * Get merchant by ID
 */
export async function getMerchantById(id: number): Promise<Merchant> {
  const response = await api.get<{ success: boolean; data: Merchant }>(
    `/merchants/${id}`
  );
  return response.data.data;
}

/**
 * Search merchants by name
 */
export async function searchMerchants(query: string): Promise<Merchant[]> {
  const response = await api.get<{ success: boolean; data: Merchant[] }>(
    `/merchants?search=${encodeURIComponent(query)}`
  );
  return response.data.data;
}
